import React from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from './contexts/LanguageContext';
import Header from './components/Header';
import Hero from './components/Hero';
import ProblemSolution from './components/ProblemSolution';
import HowItWorks from './components/HowItWorks';
import DemoSection from './components/DemoSection';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import OmOss from './components/OmOss';
import Kontakt from './components/Kontakt';

function App() {
  const LandingPage = () => (
    <>
      <Hero />
      <ProblemSolution />
      <HowItWorks />
      <DemoSection />
      <FinalCTA />
    </>
  );

  return (
    <BrowserRouter>
      <LanguageProvider>
        <div className="App">
          <Header />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/om-oss" element={<OmOss />} />
            <Route path="/kontakt" element={<Kontakt />} />
          </Routes>
          <Footer />
        </div>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
